import { KeyValue } from '@/main/models/common';
import { ParameterFilterRequest } from '@/main/models/request/parameterFilterRequest';
import { ParameterTypesResponse } from '@/main/models/response/parameterTypesResponse';

export enum ParameterTypes {
  GET_PARAMETERS = '@parameter/GET_PARAMETERS',
  SAVE_PARAMETERS = '@parameter/SAVE_PARAMETERS',
  RESET_REDUCER_PARAMETERS = '@parameter/RESET_REDUCER_PARAMETERS',
  GET_PARAMETER_BY_TYPE_AND_COMPANY = '@parameter/GET_PARAMETER_BY_TYPE_AND_COMPANY',
  SAVE_PARAMETER_BY_TYPE_AND_COMPANY = '@parameter/SAVE_PARAMETER_BY_TYPE_AND_COMPANY',
  RESET_REDUCER_PARAMETER_BY_TYPE_AND_COMPANY = '@parameter/RESET_REDUCER_PARAMETER_BY_TYPE_AND_COMPANY'
}

export interface ParameterState {
  readonly parameters: {
    data: ParameterTypesResponse[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly parameterByTypeAndCompany: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetParameters {
  type: typeof ParameterTypes.GET_PARAMETERS;
  payload: {
    request: ParameterFilterRequest;
  };
}

export interface SaveParameters {
  type: typeof ParameterTypes.SAVE_PARAMETERS;
  payload: {
    data: ParameterTypesResponse[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerParameters {
  type: typeof ParameterTypes.RESET_REDUCER_PARAMETERS;
}

export interface GetParameterByTypeAndCompany {
  type: typeof ParameterTypes.GET_PARAMETER_BY_TYPE_AND_COMPANY;
  payload: {
    request: ParameterFilterRequest;
  };
}

export interface SaveParameterByTypeAndCompany {
  type: typeof ParameterTypes.SAVE_PARAMETER_BY_TYPE_AND_COMPANY;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerParameterByTypeAndCompany {
  type: typeof ParameterTypes.RESET_REDUCER_PARAMETER_BY_TYPE_AND_COMPANY;
}

export type ParameterActionTypes =
  | GetParameters
  | SaveParameters
  | ResetReducerParameters
  | GetParameterByTypeAndCompany
  | SaveParameterByTypeAndCompany
  | ResetReducerParameterByTypeAndCompany;